var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Home_2",
    d: "M11.4465 25.9643V22.1308C11.4465 21.1558 12.2414 20.3635 13.2263 20.357H16.8339C17.8234 20.357 18.6256 21.1512 18.6256 22.1308V22.1308V25.9762C18.6254 26.804 19.2928 27.4806 20.1288 27.5H22.5339C24.9314 27.5 26.875 25.5758 26.875 23.2023V23.2023V12.2973C26.8622 11.3635 26.4193 10.4867 25.6725 9.91629L17.4472 3.35663C16.0062 2.21446 13.9578 2.21446 12.5168 3.35663L4.32753 9.9282C3.57782 10.4963 3.13423 11.3746 3.125 12.3092V23.2023C3.125 25.5758 5.06859 27.5 7.46614 27.5H9.8712C10.7279 27.5 11.4225 26.8124 11.4225 25.9643V25.9643",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.4bc54858ab867e42ce7e14a9438674ec.svg";
export { ForwardRef as ReactComponent };